'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibTextSlide = require('./components/BibTextSlide.component');

Object.defineProperty(exports, 'BibTextSlide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibTextSlide).default;
  }
});

var _SliderJacketCover = require('./components/SliderJacketCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SliderJacketCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-slider-jacket-cover/lib/index.js
// module id = 1508
// module chunks = 1